import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useLocation} from "react-router-dom";
import copy from "copy-to-clipboard"; 
import Footer from "../components/Footer";
import Header from "../components/Header";
import Nav from "../components/Nav";

const StudentThankyou = () => {
    const location = useLocation();

    const [copyUrl, setCopyUrl] = useState('');

    let hexCode = "";

    useEffect(() => {
        document.title = 'Thank You | Families of WWII Veterans';
        hexCode = location?.state?.hexCode ? location?.state?.hexCode:"" ;
        const appBaseUrl = `${window.location.origin}${process.env.PUBLIC_URL || ''}`.replace(/\/$/, '');
        let modifiedURL = `${window.location.protocol}//${window.location.hostname}`.search("code")
        let url = ""
        if(modifiedURL>-1){
            url = `${appBaseUrl}/counselor`
        }else{ 
            url = `${appBaseUrl}/counselor?code=${hexCode}`
        }
        setCopyUrl(url)
        window.scrollTo({top:0,behaviour:"smooth"})
        
    }, []);

    const handleCopy = () =>{
       
        copy(copyUrl);
        alert(`URLGOESHERE copied to your clipboard. Save this URL.`);
    }
    return (
        <>
            <Header title="Scholarship Application" />
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <Nav navbType="thankYou" />
                        <div className="card bg-primary text-center text-white mb-3">
					<div className="card-body">
                    <h3 className="card-title m-0 h3">You will be notified by 
                    email of your scholarship acceptance by the end of July or early&nbsp;August.</h3>
					</div>
				</div>
                        <h2>Thank you for your application! </h2>
                        <p className="lead">Your application will be reviewed by the Families of World War II Veterans board.</p>
                        <h3 className="text-primary h4">Please copy the link below and send it to your counselor/academic advisor to finalize your scholarship application:</h3>
                       
                        <Row className='my-3'>
                    <Col lg={2} sm={2} md={2}>
                        <button onClick={()=>handleCopy()} className="btn btn-primary btn-block">COPY LINK</button>
                    </Col>
                    <Col lg={10} sm={10} md={10} >
                        <input type="text" className="form-control" defaultValue={copyUrl} id="myInput" disabled
                        />
                    </Col>
                </Row>
                        <p className="lead">You will also receive this information in your email from sc3@careington.com.
                            If you do not receive it, please check your SPAM/Junk email box.</p>

                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default StudentThankyou;